import { render, staticRenderFns } from "./Productinventory.vue?vue&type=template&id=d017937a&scoped=true&"
import script from "./Productinventory.vue?vue&type=script&lang=js&"
export * from "./Productinventory.vue?vue&type=script&lang=js&"
import style0 from "./Productinventory.vue?vue&type=style&index=0&id=d017937a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d017937a",
  null
  
)

export default component.exports